import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { fileToSignature } from "@/lib/rab";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { Building2, Loader2, Trash2, UploadCloud } from "lucide-react";

export const CompanyLogoCard = () => {
  const [logo, setLogo] = useState("");
  const [busy, setBusy] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    api.get("/account/company-logo").then((r) => setLogo(r.data.logoImage || "")).catch(() => {});
  }, []);

  const save = async (value) => {
    setBusy(true);
    try {
      const r = await api.put("/account/company-logo", { logoImage: value });
      setLogo(r.data.logoImage || "");
      toast.success(value ? "Logo perusahaan disimpan" : "Logo perusahaan dihapus");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Gagal menyimpan logo");
    } finally {
      setBusy(false);
    }
  };

  const onFile = async (e) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = "";
    if (!file) return;
    try {
      await save(await fileToSignature(file, 500));
    } catch (err) {
      toast.error(err.message || "Gagal mengunggah logo");
    }
  };

  return (
    <Card className="p-6 mb-6 border-slate-200 bg-white" data-testid="company-logo-card">
      <div className="flex items-start gap-3 mb-4">
        <div className="w-10 h-10 rounded-xl bg-amber-100 flex items-center justify-center shrink-0">
          <Building2 className="w-5 h-5 text-amber-700" />
        </div>
        <div>
          <h2 className="font-semibold text-slate-900">Logo Perusahaan</h2>
          <p className="text-sm text-slate-500">Tampil di kiri atas Quotation, Invoice, dan semua laporan PDF. Format PNG/JPG, maks 5MB.</p>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="w-40 h-24 rounded-lg border border-dashed border-slate-300 bg-slate-50 flex items-center justify-center overflow-hidden p-2" data-testid="company-logo-preview-box">
          {logo ? (
            <img data-testid="company-logo-preview" src={logo} alt="Logo perusahaan" className="max-w-full max-h-full object-contain" />
          ) : (
            <span className="text-xs text-slate-400">Belum ada logo</span>
          )}
        </div>
        <div className="flex gap-2">
          <input ref={inputRef} type="file" accept="image/png,image/jpeg" className="hidden" onChange={onFile} data-testid="company-logo-input" />
          <Button data-testid="company-logo-upload-btn" disabled={busy} onClick={() => inputRef.current?.click()} className="bg-amber-600 hover:bg-amber-700 text-white gap-1.5">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <UploadCloud className="w-4 h-4" />}
            {logo ? "Ganti Logo" : "Upload Logo"}
          </Button>
          {logo && (
            <Button data-testid="company-logo-remove-btn" variant="outline" disabled={busy} onClick={() => save("")} className="gap-1.5 text-red-600">
              <Trash2 className="w-4 h-4" /> Hapus
            </Button>
          )}
        </div>
      </div>
    </Card>
  );
};
